import React from "react";

import {AnchorInline} from "../../style/components/general.js";

const URL_PATTERN = /https?:\/\/[^\s]+/gi;
const SHORT_URL_MAX = 40;

const shortenUrl = url => {
  try {
    const {hostname, pathname, search} = new URL(url);
    const path = `${pathname}${search}`.replace(/\/$/, "");
    const display = `${hostname}${path}`;
    if (display.length <= SHORT_URL_MAX) return display;
    return `${display.slice(0, SHORT_URL_MAX - 1)}…`;
  } catch {
    if (url.length <= SHORT_URL_MAX) return url;
    return `${url.slice(0, SHORT_URL_MAX - 1)}…`;
  }
};

const linkifyText = text => {
  if (text == null || text === "") return text;

  const value = String(text);
  const matches = Array.from(value.matchAll(new RegExp(URL_PATTERN.source, "gi")));
  if (!matches.length) return value;

  const {parts, lastIndex} = matches.reduce(
    (acc, match) => {
      if (match.index > acc.lastIndex) {
        acc.parts.push(value.slice(acc.lastIndex, match.index));
      }

      const raw = match[0];
      const href = raw.replace(/[.,;:!?)]+$/, "");
      const trailing = raw.slice(href.length);

      acc.parts.push(
        <AnchorInline
          key={`${href}-${match.index}`}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          title={href}>
          {shortenUrl(href)}
        </AnchorInline>
      );

      if (trailing) acc.parts.push(trailing);

      return {parts: acc.parts, lastIndex: match.index + raw.length};
    },
    {parts: [], lastIndex: 0}
  );

  if (lastIndex < value.length) parts.push(value.slice(lastIndex));
  return parts;
};

export default linkifyText;
